import { FundStatusWorkflowHelper } from './useFundStatusWorkflow';

export function handleInvestorOperationWithWarning(
  operationFn: () => Promise<any>,
  action: string,
  investor: any,
  callbacks: {
    setFundStatusWorkflow: (newState: object, backendWarningMessage?: string) => void;
    reloadData: () => void;
  },
  amount?: number,
): Promise<void> {
  return operationFn().then((response) => {
    if (response?.adminWarning?.requiresConfirmation) {
      return new Promise<void>((resolve, reject) => {
        FundStatusWorkflowHelper.openFundStatusConfirmModal(
          (newState) => callbacks.setFundStatusWorkflow(newState, response.adminWarning.message),
          action,
          investor,
          amount,
          () => {
            operationFn()
              .then(() => {
                callbacks.reloadData();
                resolve();
              })
              .catch(reject);
          },
        );
      });
    }

    callbacks.reloadData();
    return Promise.resolve();
  });
}
